import React, { useEffect, useMemo, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

function isOOS(u) {
  if (u.outOfService === true) return true;
  if (u.inService === false) return true;
  const s = String(u.status || "").toLowerCase();
  return s.includes("out") || s === "oos";
}

// Apparatus in/out of service from Agencies/{agency}/FleetTrack.
const FleetStatusWidget = ({ config = {}, agency }) => {
  const [units, setUnits] = useState([]);
  const showOOS = config.showOutOfService !== false;
  const hidden = config.hiddenUnits || [];

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, "Agencies", agency, "FleetTrack"),
      (snap) => {
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((u) => !hidden.includes(u.id))
          .map((u) => ({ ...u, _name: u.label || u.unitNumber || u.name || u.id, _oos: isOOS(u) }))
          .sort((a, b) => String(a._name).localeCompare(String(b._name), undefined, { numeric: true }));
        setUnits(list);
      },
      (err) => console.warn("fleet status load failed", err)
    );
    return () => unsub();
  }, [agency]); // eslint-disable-line react-hooks/exhaustive-deps

  const counts = useMemo(() => {
    const oos = units.filter((u) => u._oos).length;
    return { total: units.length, oos, inService: units.length - oos };
  }, [units]);

  const visible = showOOS ? units : units.filter((u) => !u._oos);

  return (
    <WidgetShell title="Fleet Status">
      {units.length === 0 ? (
        <EmptyState icon="🚍" label="No fleet vehicles found." />
      ) : (
        <>
          <div className="sb-fleet-counts">
            <span className="sb-fleet-count in"><b>{counts.inService}</b> In Service</span>
            <span className="sb-fleet-count oos"><b>{counts.oos}</b> Out</span>
          </div>
          <div className="sb-fleet-grid">
            {visible.map((u) => (
              <div className={`sb-unit ${u._oos ? "oos" : "in"}`} key={u.id}>
                <span className="sb-unit-name">{u._name}</span>
                <span className="sb-unit-status">{u._oos ? "OOS" : "In Service"}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </WidgetShell>
  );
};

export default FleetStatusWidget;
